import Phaser from 'phaser';
import { Direction } from '@shared/types/entity';
import { TILE_SIZE } from '@shared/constants';

/**
 * Sprites de casco (helmet):
 * - 1 fila, 4 columnas (sin animación).
 * - Col 0: mira abajo
 * - Col 1: mira derecha
 * - Col 2: mira izquierda
 * - Col 3: mira arriba
 *
 * Los PNG actuales de helmet (`helmet1.png`, `helmet2.png`, etc.) son una tira
 * horizontal de 4 columnas x 1 fila, similar a las heads.
 * Usamos el mismo tamaño de frame que las heads para consistencia.
 */
const HELMET_COLUMNS = 4;
const HELMET_FRAME_WIDTH = 23;
const HELMET_FRAME_HEIGHT = 30;

export function getHelmetSpriteKey(helmetId: number): string {
  return `helm${helmetId}`;
}

export function preloadHelmetSprites(scene: Phaser.Scene, helmetIds: number[]): void {
  for (const id of helmetIds) {
    const key = getHelmetSpriteKey(id);
    // Asegurarnos de que el recurso sea SIEMPRE un spritesheet
    // (si antes se cargó como imagen simple, lo eliminamos primero).
    if (scene.textures.exists(key)) {
      scene.textures.remove(key);
    }

    scene.load.spritesheet(key, `assets/helm/${key}.png`, {
      frameWidth: HELMET_FRAME_WIDTH,
      frameHeight: HELMET_FRAME_HEIGHT,
    });
  }
}

/**
 * Devuelve el índice de frame de casco según la dirección.
 * 0: abajo, 1: derecha, 2: izquierda, 3: arriba.
 */
export function getHelmetFrameForDirection(dir: Direction): number {
  switch (dir) {
    case Direction.DOWN:
      return 0;
    case Direction.RIGHT:
      return 1;
    case Direction.LEFT:
      return 2;
    case Direction.UP:
      return 3;
    default:
      return 0;
  }
}

